"use client"

import { useState, useEffect } from "react"
import { Card, Button, Form, Spinner } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { getSettingUsersAction, updateSettingUserAction } from "../../../store/actions/SettingAction"
import Loader from "../Common/Loader"

const CountdownTimer = ({ count, delay, onComplete }) => {
  const [currentCount, setCurrentCount] = useState(count)
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    const delayTimer = setTimeout(() => setIsActive(true), delay)
    return () => clearTimeout(delayTimer)
  }, [delay])

  useEffect(() => {
    let timer
    if (isActive && currentCount > 0) {
      timer = setInterval(() => setCurrentCount((prev) => prev - 1), 1000)
    } else if (currentCount === 0 && isActive) {
      onComplete?.()
    }
    return () => clearInterval(timer)
  }, [isActive, currentCount, onComplete])

  return (
    <div
      className="text-center py-3 mt-3"
      style={{ backgroundColor: "#f8f9fa", borderRadius: "10px", border: "1px solid #dee2e6" }}
    >
      <h5 className="mb-0" style={{ color: "#495057", fontWeight: "500" }}>
        {!isActive
          ? `⏳ Countdown will start after delay...`
          : currentCount > 0
            ? `⏳ Time remaining: ${currentCount} seconds`
            : "✅ Time is up!"}
      </h5>
    </div>
  )
}

const SiteSetting = () => {
  const dispatch = useDispatch()
  const [count, setCount] = useState("")
  const [followUp, setFollowUp] = useState("")
  const [delay, setDelay] = useState(3000)
  const [loading, setLoading] = useState(true)
  const [startCountdown, setStartCountdown] = useState(false)
  const { settings } = useSelector((state) => state.setting)
  const [consultingId, setConsultingId] = useState(null)
  const [repeatingId, setRepeatingId] = useState(null)
  const [leadId, setLeadId] = useState(null)
  const [consultingFees, setConsultingFees] = useState("")
  const [repeatingFees, setRepeatingFees] = useState("")
  const [saving, setSaving] = useState(false)

  const [followUpId, setFollowUpId] = useState(null)
  const [onlineConsultingFees, setOnlineConsultingFees] = useState("");
  const [onlineConsultingId, setOnlineConsultingId] = useState(null);

  const [onlineRepeatingFees, setOnlineRepeatingFees] = useState("");
  const [onlineRepeatingId, setOnlineRepeatingId] = useState(null);

  const [attemptsReceived, setAttemptsReceived] = useState("")
  const [attemptsNotReceived, setAttemptsNotReceived] = useState("")
  const [shufflingDuration, setShufflingDuration] = useState("")
  const [attemptsReceivedId, setAttemptsReceivedId] = useState(null)
  const [attemptsNotReceivedId, setAttemptsNotReceivedId] = useState(null)
  const [shufflingDurationId, setShufflingDurationId] = useState(null)
  const [serviceCallFrequency, setServiceCallFrequency] = useState("");
  const [serviceCallFrequencyId, setServiceCallFrequencyId] = useState(null);
  
  // New state for Dropped Patients Duration
  const [droppedPatientsDuration, setDroppedPatientsDuration] = useState("");
  const [droppedPatientsDurationId, setDroppedPatientsDurationId] = useState(null);

  const fetchSettings = async () => {
    setLoading(true)
    try {
      const settings = await dispatch(getSettingUsersAction())
      if (settings) {
        settings.forEach((s) => {
          if (s.setting_name === "Online Consulting Fees") {
            setOnlineConsultingFees(s.setting_value);
            setOnlineConsultingId(s.setting_id);
          }
          if (s.setting_name === "Online Repeating Consulting Fees") {
            setOnlineRepeatingFees(s.setting_value);
            setOnlineRepeatingId(s.setting_id);
          }
          if (s.setting_name === "Lead Delay Count (Days)") {
            setCount(s.setting_value)
            setLeadId(s.setting_id)
          }
          if (s.setting_name === "Follow-up Frequency (Days)") {
            setFollowUp(s.setting_value)
            setFollowUpId(s.setting_id)
          }
          if (s.setting_name === "Consulting Fees") {
            setConsultingFees(s.setting_value)
            setConsultingId(s.setting_id)
          }
          if (s.setting_name === "Repeating Consulting Fees") {
            setRepeatingFees(s.setting_value)
            setRepeatingId(s.setting_id)
          }
          if (s.setting_name === "Service Call Frequency (custom medicines/prescription)") {
            setServiceCallFrequency(s.setting_value);
            setServiceCallFrequencyId(s.setting_id);
          }
          // Add Dropped Patients Duration setting
          if (s.setting_name === "Dropped Patients Duration (Days)") {
            setDroppedPatientsDuration(s.setting_value);
            setDroppedPatientsDurationId(s.setting_id);
          }
          if (s.setting_name === "Lead Attempts Received") {
            setAttemptsReceived(s.setting_value)
            setAttemptsReceivedId(s.setting_id)
          }
          if (s.setting_name === "Lead Attempts Not Received") {
            setAttemptsNotReceived(s.setting_value)
            setAttemptsNotReceivedId(s.setting_id)
          }
          if (s.setting_name === "Lead Shuffling Duration") {
            setShufflingDuration(s.setting_value)
            setShufflingDurationId(s.setting_id)
          }
        })
      }
    } catch (err) {
      console.error("Failed to fetch settings:", err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchSettings()
  }, [dispatch])

  const handleStart = async () => {
    if (saving) return
    setSaving(true)
    const payload = {
      setting_update: [
        {
          setting_id: String(leadId),
          setting_name: "Lead Delay Count (Days)",
          setting_value: String(count),
        },
        {
          setting_id: String(followUpId),
          setting_name: "Follow-up Frequency (Days)",
          setting_value: String(followUp),
        },
        {
          setting_id: String(consultingId),
          setting_name: "Consulting Fees",
          setting_value: String(consultingFees),
        },
        {
          setting_id: String(repeatingId),
          setting_name: "Repeating Consulting Fees",
          setting_value: String(repeatingFees),
        },
        {
          setting_id: String(onlineConsultingId),
          setting_name: "Online Consulting Fees",
          setting_value: String(onlineConsultingFees),
        },
        {
          setting_id: String(onlineRepeatingId),
          setting_name: "Online Repeating Consulting Fees",
          setting_value: String(onlineRepeatingFees),
        },
        {
          setting_id: String(serviceCallFrequencyId),
          setting_name: "Service Call Frequency (custom medicines/prescription)",
          setting_value: String(serviceCallFrequency),
        },
        {
          setting_id: String(droppedPatientsDurationId),
          setting_name: "Dropped Patients Duration (Days)",
          setting_value: String(droppedPatientsDuration),
        },
        {
          setting_id: String(attemptsReceivedId),
          setting_name: "Lead Attempts Received",
          setting_value: String(attemptsReceived),
        },
        {
          setting_id: String(attemptsNotReceivedId),
          setting_name: "Lead Attempts Not Received",
          setting_value: String(attemptsNotReceived),
        },
        {
          setting_id: String(shufflingDurationId),
          setting_name: "Lead Shuffling Duration",
          setting_value: String(shufflingDuration),
        },
      ],
    }

    try {
      await dispatch(updateSettingUserAction(payload))
      setStartCountdown(false)
      setTimeout(() => setStartCountdown(true), 50)
      await fetchSettings() // refresh after update
    } catch (err) {
      console.error("Failed to update settings:", err)
    } finally {
      setSaving(false)
    }
  }

  if (loading) {
    return (
      <div className="text-center my-5">
        <Loader size="lg" />
      </div>
    )
  }

  return (
    <div className="row justify-content-center mt-5">
      <div className="col-xl-12">
        <Card className="shadow border-0">
          <Card.Body>
            <div style={{ overflowY: "auto", maxHeight: "90vh" }}>
              <Form>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="leadDelay" className="form-label">
                      Lead Delay Count (Days)
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="leadDelay"
                      placeholder="Enter lead delay in days"
                      min="1"
                      value={count}
                      onChange={(e) => setCount(e.target.value)}
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="followUp" className="form-label">
                      Follow-up Frequency (Days)
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter follow-up frequency in days"
                      id="followUp"
                      min="1"
                      value={followUp}
                      onChange={(e) => setFollowUp(e.target.value)}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-3">
                    <label className="form-label">Consulting Fees (Offline)</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Offline consulting fee"
                      value={consultingFees}
                      onChange={(e) => setConsultingFees(e.target.value)}
                    />
                  </div>

                  <div className="col-md-3">
                    <label className="form-label">Repeating Consulting Fees (Offline)</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Offline repeating fee"
                      value={repeatingFees}
                      onChange={(e) => setRepeatingFees(e.target.value)}
                    />
                  </div>

                  <div className="col-md-3">
                    <label className="form-label">Consulting Fees (Online)</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Online consulting fee"
                      value={onlineConsultingFees}
                      onChange={(e) => setOnlineConsultingFees(e.target.value)}
                    />
                  </div>

                  <div className="col-md-3">
                    <label className="form-label">Repeating Consulting Fees (Online)</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Online repeating fee"
                      value={onlineRepeatingFees}
                      onChange={(e) => setOnlineRepeatingFees(e.target.value)}
                    />
                  </div>
                </div>
                
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="serviceCallFrequency" className="form-label">
                      Service Call Frequency (custom medicines/prescription)
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="serviceCallFrequency"
                      placeholder="Enter frequency in days"
                      min="1"
                      value={serviceCallFrequency}
                      onChange={(e) => setServiceCallFrequency(e.target.value)}
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="droppedPatientsDuration" className="form-label">
                      Dropped Patients Duration (Days)
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="droppedPatientsDuration"
                      placeholder="Enter dropped patients duration in days"
                      min="1"
                      value={droppedPatientsDuration}
                      onChange={(e) => setDroppedPatientsDuration(e.target.value)}
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <h6 className="form-label" style={{ fontWeight: "1000", fontSize: "18px", marginBottom: "15px" }}>
                    Leads Shuffling Settings
                  </h6>
                </div>
                
                <div className="row mb-3">
                  <div className="col-md-4">
                    <label htmlFor="attemptsReceived" className="form-label">
                      No. Attempts Received
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="attemptsReceived"
                      placeholder="Enter attempts received"
                      min="1"
                      value={attemptsReceived}
                      onChange={(e) => setAttemptsReceived(e.target.value)}
                    />
                  </div>

                  <div className="col-md-4">
                    <label htmlFor="attemptsNotReceived" className="form-label">
                      No. Attempts Not Received
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="attemptsNotReceived"
                      placeholder="Enter attempts not received"
                      min="1"
                      value={attemptsNotReceived}
                      onChange={(e) => setAttemptsNotReceived(e.target.value)}
                    />
                  </div>

                  <div className="col-md-4">
                    <label htmlFor="shufflingDuration" className="form-label">
                      Duration (Days)
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="shufflingDuration"
                      placeholder="Enter shuffling duration in days"
                      min="1"
                      value={shufflingDuration}
                      onChange={(e) => setShufflingDuration(e.target.value)}
                    />
                  </div>
                </div>

                <Button variant="primary" className="mt-2" onClick={handleStart} disabled={saving}>
                  {saving ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Saving...
                    </>
                  ) : (
                    "Save Settings"
                  )}
                </Button>
              </Form>
            </div>
          </Card.Body>
        </Card>
      </div>
    </div>
  )
}

export default SiteSetting